
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import TacosScreen from './tacos';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import BottleScreen from './bottle';
import ClassicCocktailsScreen from './classicCocktails';
import BeersScreen from './beers';
import Alcoholic from './alcoholic';
import ColdBerevagesScreen from './coldberevages';


function Index({setShowHappy}) { 

     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [signature, setsignature] = useState(false);
    const [frozen, setfrozen] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
        const [showBottle, setShowBottle] = useState(false);
        const [showClassicCocktails, setShowClassicCocktails] = useState(false);
        const [showBeers, setShowBeers] = useState(false);
    const [showTacos, setShowTacos] = useState(false);
    const [naturalWater, setnaturalWater] = useState(false);
    const [showColdBerevages, setShowColdBerevages] = useState(false);
    
     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
            setMenusData(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 856) {
                setsignature(item);
            }
            if (item.id === 803) {
                setfrozen(item);
            }
            if (item.id === 857) {
                setnaturalWater(item);
            }
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={setshowCategories} showCocktails={setShowCocktails} showEvents={setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                
                <div style={{
                    background: 'linear-gradient(180deg, #5f3c24 0%, #4a2f1d 55%, #3a2416 100%)',
                    width: '93%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '8px 10px',
                    gap: 15,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 12,
                    border: '1px solid rgba(205, 140, 86, 0.45)',
                    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.3), inset 0px 1px 0px rgba(255, 214, 170, 0.18)'
                }}>
                    {menusData.map((item, key) => {
                        if (![767, 444, 445, 446, 448, 449, 450,
                            429, 430, 425, 424, 555, 565,
                            564, 566, 567, 791, 798, 792, 797].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: 'linear-gradient(180deg, #c48a52 0%, #a96b3a 60%, #8b552f 100%)',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '10px 25px',
                                    borderRadius: 10,
                                    minWidth: 'fit-content',
                                    border: '1px solid rgba(89, 48, 21, 0.6)',
                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.25), inset 0px 1px 0px rgba(255, 220, 180, 0.28)'
                            }}
                                    onClick={() => { 
                                        if (item.id === 855) {
                                            setShowTacos(true);
                                        } else {
                                            setShowListProduct(true)
                                            setdishs(item)
                                        }
                                }}
                                >
                                    <p className='shor-text' style={{
                                        color: '#f8d28e', fontFamily: 'serif', fontSize: 16,
                                        margin: 0, textTransform: 'uppercase',
                                        fontWeight: '500', fontFamily: 'Galantic',
                                        lineHeight: 1,
                                        textShadow: '0px 2px 0px rgba(75, 39, 14, 0.9), 0px 4px 6px rgba(0, 0, 0, 0.35)'
                                    }}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>


                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        <div
                        onClick={() => {
                            setShowListProduct(true)
                            setdishs(naturalWater)
                        }}
                        >
                            <img
                            src={require('./assets/NATURALWATHERS.png')}
                            onContextMenu={(e) => e.preventDefault()}
                                style={{
                                marginTop: 10,
                                width: '100%',
                                height: 240,
                             
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>

                        <div
                        onClick={() => {
                           setShowColdBerevages(true)
                        }}
                        >
                            <img
                            src={require('./assets/COLD.png')}
                            onContextMenu={(e) => e.preventDefault()}
                                style={{
                               
                                width: '100%',
                                height: 240,
                            
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>


                        <div
                        onClick={() => {
                            setShowListProduct(true)
                            setdishs(signature)
                        }}
                        >
                            <img
                            src={require('./assets/hot-drinks.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '100%',
                                height: 240,
                             
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>

                       



                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showClassicCocktails && <ClassicCocktailsScreen setShowHappy={setShowClassicCocktails} />}
                {showBeers && <BeersScreen setShowHappy={setShowBeers} />}
                {showTacos && <TacosScreen setShowHappy={setShowTacos} />}
                {showColdBerevages && <ColdBerevagesScreen setShowHappy={setShowColdBerevages} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;